import React, { useState } from 'react';
import { archiveAPI } from '../services/api';
import styles from './Archive.module.css';

export default function Archive() {
  const toLocalDateString = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const now = new Date();
  const oneMonthAgo = new Date(now);
  oneMonthAgo.setMonth(now.getMonth() - 1);

  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    startDate: toLocalDateString(oneMonthAgo),
    endDate: toLocalDateString(now),
    search: '',
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleSearch = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await archiveAPI.search(filters);
      setEntries(response.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to search archive');
    } finally {
      setLoading(false);
    }
  };

  const handleExportCSV = () => {
    if (entries.length === 0) {
      alert('No entries to export');
      return;
    }

    let csv = 'Date,Company,Start Time,End Time,Description\n';
    entries.forEach((entry) => {
      csv += `${entry.date},"${entry.company_name}",${entry.start_time},${entry.end_time},"${entry.description || ''}"\n`;
    });

    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `archive-${filters.startDate}-${filters.endDate}.csv`;
    a.click();
  };

  return (
    <div className={styles.container}>
      <h1>Archive Search</h1>

      {error && <div className={styles.error}>{error}</div>}

      <div className={styles.filterSection}>
        <h2>Search Archived Entries</h2>
        <div className={styles.filterGrid}>
          <div className={styles.filterGroup}>
            <label htmlFor="startDate">Start Date:</label>
            <input
              type="date"
              id="startDate"
              name="startDate"
              value={filters.startDate}
              onChange={handleFilterChange}
            />
          </div>

          <div className={styles.filterGroup}>
            <label htmlFor="endDate">End Date:</label>
            <input
              type="date"
              id="endDate"
              name="endDate"
              value={filters.endDate}
              onChange={handleFilterChange}
            />
          </div>

          <div className={styles.filterGroup}>
            <label htmlFor="search">Search Description:</label>
            <input
              type="text"
              id="search"
              name="search"
              placeholder="Search..."
              value={filters.search}
              onChange={handleFilterChange}
            />
          </div>
        </div>

        <div className={styles.buttonGroup}>
          <button onClick={handleSearch} disabled={loading} className={styles.btnPrimary}>
            {loading ? 'Searching...' : 'Search'}
          </button>
          <button onClick={handleExportCSV} disabled={entries.length === 0} className={styles.btnSecondary}>
            Export to CSV
          </button>
        </div>
      </div>

      {loading && <p>Loading...</p>}

      {!loading && entries.length === 0 && (
        <p className={styles.noResults}>No entries found. Try adjusting your search criteria.</p>
      )}

      {!loading && entries.length > 0 && (
        <div className={styles.resultsSection}>
          <h2>Results ({entries.length} entries)</h2>
          <div className={styles.entriesList}>
            {entries.map((entry) => (
              <div key={entry.id} className={styles.entryCard}>
                <div className={styles.entryHeader}>
                  <strong>{entry.company_name}</strong>
                  <span className={styles.date}>{entry.date}</span>
                </div>
                <p>
                  <strong>Time:</strong> {entry.start_time} - {entry.end_time}
                </p>
                <p>
                  <strong>Description:</strong> {entry.description || 'N/A'}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
